// When each review action means something for a reviewed row.

import { isSnoozed } from "./snooze.ts";
import type { ReviewState, ReviewSubject } from "./types.ts";

export const REVIEW_LABELS: Record<ReviewState, string> = {
  accepted: "Pursuing",
  pending: "To review",
  disqualified: "Disqualified",
};

/** Whether Pursue / Disqualify can do anything right now. */
export function canReview(s: Pick<ReviewSubject, "review_state" | "awaiting_approval">): boolean {
  // On a list already, or a parked step may be the one waiting (the server
  // tells us if it was not).
  return s.review_state !== null || s.awaiting_approval;
}

/** Whether it is on the worklist: pursued and not done. */
export function onWorklist(s: Pick<ReviewSubject, "review_state" | "done_at">): boolean {
  return s.review_state === "accepted" && !s.done_at;
}

/** Whether Done means something here: on the worklist, or done already. */
export function canMarkDone(s: Pick<ReviewSubject, "review_state" | "done_at">): boolean {
  return !!s.done_at || onWorklist(s);
}

/** Only the worklist's rows snooze; a snoozed one can always have it taken off. */
export function canSnooze(
  s: Pick<ReviewSubject, "review_state" | "done_at" | "snoozed_until">,
): boolean {
  return onWorklist(s) || isSnoozed(s.snoozed_until);
}

export const plural = (n: number, word: string) => `${n} ${word}${n === 1 ? "" : "s"}`;
